export type PeriodDisplayMode = 'months' | 'quarters' | 'years'

const monthsPerPeriod = (mode: PeriodDisplayMode) => mode === 'years' ? 12 : mode === 'quarters' ? 3 : 1

export const periodDisplayBounds = (mode: PeriodDisplayMode) => ({ min: 1, max: 120 / monthsPerPeriod(mode) })

export const clampPeriodCount = (mode: PeriodDisplayMode, count: number) => {
  const bounds = periodDisplayBounds(mode)
  const normalized = Number.isFinite(count) ? Math.round(count) : 1
  return Math.max(bounds.min, Math.min(bounds.max, normalized))
}

/** Grouping changes only the display unit; an explicit count edit changes history. */
export const periodCountForMonths = (mode: PeriodDisplayMode, months: number) =>
  clampPeriodCount(mode, Math.ceil(months / monthsPerPeriod(mode)))

export const monthsForPeriodCount = (mode: PeriodDisplayMode, count: number) =>
  clampPeriodCount(mode, count) * monthsPerPeriod(mode)

/** The existing comparison buffer is separate from the selected display span. */
export const statementFetchMonths = (months: number) => Math.max(24, Math.min(120, months))
